/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiTracksIdQueryResponse, GetApiTracksIdPathParams, GetApiTracksId400, GetApiTracksId401, GetApiTracksId403, GetApiTracksId404, GetApiTracksId500 } from "../../types/GetApiTracksId.ts";
import { getApiTracksIdQueryResponseSchema } from "../../zod/TracksSchemas/getApiTracksIdSchema.ts";

function getGetApiTracksIdUrl({ id }: { id: GetApiTracksIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/tracks/${id}` as const }  
  return res
}

/**
 * @summary Получение трека по идентификатору
 * {@link /api/tracks/:Id}
 */
export async function getApiTracksId({ id }: { id: GetApiTracksIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiTracksIdQueryResponse, ResponseErrorConfig<GetApiTracksId400 | GetApiTracksId401 | GetApiTracksId403 | GetApiTracksId404 | GetApiTracksId500>, unknown>({ method : "GET", url : getGetApiTracksIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiTracksIdQueryResponseSchema.parse(res.data)
}